import { CompositeAnalyticsProvider } from './providers/composite';
import { PostHogAnalyticsProvider } from './providers/posthog';
import { YandexMetrikaProvider } from './providers/yandexMetrika';
import { AnalyticsEvent } from './events';

// Хуки и сторы берут аналитику отсюда, а не из index.ts: тот тянет React-контекст
// и роутер, которые в юнит-тестах логики не нужны.
export { AnalyticsEvents } from './events';

/** Единственный экземпляр аналитики: PostHog + Яндекс.Метрика. */
export const analytics = new CompositeAnalyticsProvider([
  new PostHogAnalyticsProvider(),
  new YandexMetrikaProvider(),
]);

/**
 * Событие вне React-компонента — из onSuccess мутаций и сторов, где хука
 * `useAnalytics()` нет. В компонентах по-прежнему `useAnalytics().track`.
 * В свойствах — только перечислимые признаки (тип, формат, статус): никаких
 * имён, текстов и идентификаторов людей.
 */
export const trackEvent = (event: AnalyticsEvent, properties?: Record<string, unknown>): void =>
  analytics.track(event, properties);
